import React from 'react';
import PropTypes from 'prop-types';
import enhance from './enhance';
import styles from './styles.module.scss';
import InCartTemplateRow from './InCartTemplateRow';
import SubsectionSummary from './SubsectionSummary';

export const Subsection = ({
  subsection,
  templateIdsInOrder,
  modelString,
  optionClusterString,
  totalPriceString,
  quantityString,
  priorityString,
  selectAllString,
  selectAll,
  columnLabels,
  selectAllStyle,
  mini,
}) => {
  return (
    <div className={styles.Subsection}>
      <SubsectionSummary
        name={subsection.description}
        templateIdsInOrder={templateIdsInOrder}
      />
      <div className={styles.columnLabels}>
        {!mini && <span className={styles.modelColumn}>{modelString}</span>}
        <span className={styles.optionClusterColumn}>
          {optionClusterString}
        </span>
        <span className={styles.designOptionColumn}>
          {columnLabels.map((label, i) => <span key={i}>{label}</span>)}
        </span>
        <span className={styles.totalPriceColumn}>{totalPriceString}</span>
        <span className={styles.quantityColumn}>{quantityString}</span>
        <span className={styles.priorityColumn}>Priority</span>
        <span className={styles.priorityColumn} />
        <span
          className={styles.selectAll}
          style={selectAllStyle}
          onClick={selectAll}
        >
          {selectAllString}
        </span>
      </div>
      {templateIdsInOrder.map(templateId => (
        <InCartTemplateRow key={templateId} templateId={templateId} />
      ))}
    </div>
  );
};

Subsection.propTypes = {
  subsection: PropTypes.object.isRequired,
  templateIdsInOrder: PropTypes.array,
  modelString: PropTypes.string.isRequired,
  optionClusterString: PropTypes.string.isRequired,
  totalPriceString: PropTypes.string.isRequired,
  quantityString: PropTypes.string.isRequired,
  priorityString: PropTypes.string.isRequired,
  selectAllString: PropTypes.string.isRequired,
  selectAll: PropTypes.func.isRequired,
};

export default enhance(Subsection);
